import { render, staticRenderFns } from "./OpenIDConnect.vue?vue&type=template&id=0d3e18b0"
import script from "./OpenIDConnect.vue?vue&type=script&lang=js"
export * from "./OpenIDConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports